import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import {MessageService} from 'primeng/api';
@Injectable({
  providedIn: 'root'
})
export class UserVerifiedGuardService {

  constructor(private auth:AuthService,public router:Router,private messageService: MessageService) { }
  canActivate():boolean{
    if(this.auth.user.country_id == 233 && this.auth.user.verified && this.auth.user.email_verified_at){
      return true
    }
    else if(this.auth.user.country_id == 39 && this.auth.user.verified && this.auth.user.email_verified_at){
      return true
    }
    else{
      this.messageService.add({severity:'error', summary:'Update account first', detail:''});
      return false
    }
  }
}
